import React, {useEffect, useState} from 'react'
import _ from "lodash";
import {PRODUCT_COLOR_FILTER_LIST, PRODUCT_DETAIL_KEY, PRODUCT_SIZE_FILTER_LIST} from "../../../constants/pod.constant";
import SearchBox from "../../../../common/ui/search-box";
import RenderFields from "../../../../common/ui/render-fields";
import {convertInchToPixel} from "../../../utils/dimension-util";

const ParentProductSizeList = ({parentProduct, setParentProduct, fieldList}) => {
    const [productSizeList, setProductSizeList] = useState(parentProduct?.sizes);
    const [enableEdit, setEnableEdit] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [selectedSizeType, setSelectedSizeType] = useState('all');

    const handleSizeDetailChanges = (event, rowIndex, sizeDetail) => {
        const {name, value} = event.target;
        sizeDetail[name] = value;

        if (name === PRODUCT_DETAIL_KEY.HEIGHT_INCH) {
            sizeDetail[PRODUCT_DETAIL_KEY.HEIGHT_PIXEL] = convertInchToPixel(value);
        } else if (name === PRODUCT_DETAIL_KEY.WIDTH_INCH) {
            sizeDetail[PRODUCT_DETAIL_KEY.WIDTH_PIXEL] = convertInchToPixel(value);
        }

        const existingParentProduct = {...parentProduct};
        const sizeIndex = _.findIndex(existingParentProduct.sizes, ['name', sizeDetail.name])
        existingParentProduct.sizes[sizeIndex] = sizeDetail;
        setParentProduct(existingParentProduct);
    }

    const handleClearSearch = () => {
        setSearchText('');
    }

    useEffect(() => {
        prepareFilteredProductSizeList(selectedSizeType);
    }, [searchText]);

    const prepareFilteredProductSizeList = (sizeType?) => {
        let filteredProductSizeList = [];

        _.forEach(parentProduct?.sizes, sizeDetail => {
            if (searchText) {
                if (_.toLower(sizeDetail.name).indexOf(_.toLower(searchText)) !== -1) {
                    applySelectedSizeTypeFilter(filteredProductSizeList, sizeDetail, sizeType);
                }
            } else {
                applySelectedSizeTypeFilter(filteredProductSizeList, sizeDetail, sizeType);
            }

        });

        setProductSizeList(filteredProductSizeList);
    }

    const applySelectedSizeTypeFilter = (filteredProductSizeList, sizeDetail, sizeType) => {
        if (sizeType) {
            if (sizeType === 'all') {
                filteredProductSizeList.push(sizeDetail);
            } else if (sizeType === 'single' && sizeDetail.isSingle) {
                filteredProductSizeList.push(sizeDetail);
            } else if (sizeType === 'multi' && !sizeDetail.isSingle) {
                filteredProductSizeList.push(sizeDetail);
            }
        } else {
            filteredProductSizeList.push(sizeDetail);
        }
    }

    const handleSizeTypeChanges = (event) => {
        const {name, value} = event.target;
        const existingParentProduct = {...parentProduct};
        existingParentProduct[name] = value;

        existingParentProduct.isMultiMeasurement = (value === 'multi-measurements');

        setParentProduct(existingParentProduct);
    }

    return (
        <>

            <div className="flex justify-between w-full">

                <div className="flex justify-start flex-wrap">
                    <div className="-ml-2">
                        <SearchBox
                            label={'Search Sizes'}
                            searchText={searchText}
                            setSearchText={setSearchText}/>
                    </div>

                    <div className="field-container">
                        {!enableEdit &&
                            <select
                                className="input-field"
                                id="sizeType"
                                name="sizeType"
                                disabled={true}
                                value={parentProduct?.sizeType}
                                onChange={handleSizeTypeChanges}>
                                {PRODUCT_SIZE_FILTER_LIST?.map((option, index) => (
                                    <option key={index}
                                            value={option?.key}>{option?.label}</option>
                                ))}
                            </select>
                        }

                        {enableEdit &&
                            <select
                                className="input-field"
                                id="sizeType"
                                name="sizeType"
                                value={parentProduct?.sizeType}
                                onChange={handleSizeTypeChanges}>
                                {PRODUCT_SIZE_FILTER_LIST?.map((option, index) => (
                                    <option key={index}
                                            value={option?.key}>{option?.label}</option>
                                ))}
                            </select>
                        }
                    </div>
                </div>

                <div className="float-right">
                    <button
                        onClick={() => setEnableEdit(!enableEdit)}
                        className="button-small mt-2 ml-4 w-48">
                        {!enableEdit && <span>Edit Fields</span>}
                        {enableEdit && <span>Ready Only Fields</span>}
                    </button>
                </div>

            </div>

            <div className="overflow-y-scroll bg-white mt-4">
                <table className="w-full">
                    <thead className="">
                    <tr>
                        <th className="px-2 py-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">
                            Size
                        </th>
                        <th className="px-2 py-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">
                            Width (Inch)
                        </th>
                        <th className="px-2 py-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">
                            Height (Inch)
                        </th>
                        <th className="px-2 py-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">
                            Width (Pixel)
                        </th>
                        <th className="px-2 py-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">
                            Height (Pixel)
                        </th>
                    </tr>
                    </thead>
                    <tbody className="">
                    {productSizeList?.map((productSize, rowIndex) => (
                        <tr key={`row-${rowIndex}`} className="border border-gray-400">
                            <td className="p-2 border border-gray-400">
                                <div>{productSize?.name}</div>
                            </td>

                            {fieldList?.map((field, index) => (
                                <td key={`row-${rowIndex}-field-${index}`}
                                    className={`p-2 border border-gray-400 ${enableEdit ? 'bg-gray-200' : ''}`}>
                                    {!enableEdit &&
                                        <div>{productSize[field.attribute]}</div>
                                    }

                                    {enableEdit &&
                                        <>
                                            <input
                                                type="number"
                                                className="input-field w-full"
                                                id={field.attribute}
                                                name={field.attribute}
                                                value={productSize[field.attribute] || ''}
                                                onChange={(event) => {
                                                    handleSizeDetailChanges(event, rowIndex, productSize);
                                                }}>
                                            </input>
                                        </>
                                    }
                                </td>
                            ))}

                        </tr>

                    ))}
                    </tbody>
                </table>
            </div>

        </>
    )
}

export default ParentProductSizeList
